import { lazy, Suspense } from "react";

import { Spinner } from "@app/components/spinners/spinner";

const ImporterCurateHomeOutletAppPermission = lazy(() => {
  return new Promise<{ default: React.FC }>((resolve, reject) => {
    import("@honeycomb/curate-home")
      .then((lib) => {
        resolve({
          default: () => <lib.AppPermission />,
        });
      })
      .catch(reject);
  });
});

export const LazyCurateHomeOutletAppPermission = () => {
  return (
    <Suspense fallback={<Spinner height={"100vh"} />}>
      <ImporterCurateHomeOutletAppPermission />
    </Suspense>
  );
};
